<template>
  <table class="account-info-table" style="width: 100%">
    <tr class="h-8">
      <td class="font-500">{{ $t('payment.bank-name') }}</td>
      <td>{{ $t('payment.default-bank') }}</td>
    </tr>
    <tr class="h-8">
      <td class="font-500">{{ $t('payment.account-number') }}</td>
      <td class="account-info-cell">495077125
        <copy-button value="495077125" />
      </td>
    </tr>
    <tr class="h-8">
      <td class="font-500">{{ $t('payment.account-name') }}</td>
      <td class="account-info-cell">
        <copy-button value="" /></td>
    </tr>
    <tr class="h-8">
      <td class="font-500">{{ $t('payment.transaction-amount') }}</td>
      <td>5,000₮</td>
    </tr>
    <tr class="h-8">
      <td class="font-500">{{ $t('payment.transaction-text') }}</td>
      <td class="account-info-cell">{{ $t('payment.default-transaction-text', { slot: user.register_number }) }}
        <copy-button :value="`${ $t('payment.default-transaction-text', { slot: user.register_number }) }`" /></td>
    </tr>
  </table>
</template>

<script>
import CopyButton from '../global/CopyButton'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    CopyButton,
  },
  created() {
    if (this.user === null) {
      this.fetchUser()
    }
  },
  computed: {
    ...mapState('user', ['user']),
  },
  methods: {
    ...mapActions('user', ['fetchUser']),
  },
}
</script>

<style lang='scss' scoped>
@import "./AccountInfoTable.scss";
</style>
